// extracted by mini-css-extract-plugin
module.exports = {"googleInstructions":"CalendarURL_googleInstructions__1XqGx","googleInstructionsTextBlock":"CalendarURL_googleInstructionsTextBlock__1AqJm","media":"CalendarURL_media__3Drl9"};